export enum ReportsTitleByNumber {
  MINUTES = "minutes",
  PERCENTAGE = "percentage",
}
